import { render, staticRenderFns } from "./ProcessHeader.vue?vue&type=template&id=cd12910c&scoped=true"
import script from "./ProcessHeader.vue?vue&type=script&lang=js"
export * from "./ProcessHeader.vue?vue&type=script&lang=js"
import style0 from "./ProcessHeader.vue?vue&type=style&index=0&id=cd12910c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd12910c",
  null
  
)

export default component.exports